import * as React from 'react'

import { NextPage } from '@grandvisionhq/next'
import {
  ErrorCase,
  InitialProps,
  LegacyPage,
  Props,
} from '@grandvisionhq/www-next/pages/product-detail-legacy'
import { PromoteInstallmentsRestContainer } from '@grandvisionhq/www-next/slot-components/PromoteInstallmentsRestContainer'

import { composePDP } from '../../components/hocs/compose-pdp'
import { settings as cartSettings } from '../../components/hocs/with-cart'
import { getDeliveryIndicatorConfig, promoteInstallmentsConfiguration } from '../../configuration'

const slots: Props['slots'] = {
  AfterPrice: () => (
    <PromoteInstallmentsRestContainer opcoConfiguration={promoteInstallmentsConfiguration} />
  ),
}

const ProductDetailPage: NextPage<Props, InitialProps | ErrorCase> = (props) => {
  const deliveryIndicatorConfig = getDeliveryIndicatorConfig()

  return (
    <LegacyPage
      {...props}
      slots={slots}
      clAndSolutionsMaxOrderableQuantity={cartSettings.maximumQuantity}
      deliveryIndicatorConfig={deliveryIndicatorConfig}
    />
  )
}

ProductDetailPage.getInitialProps = LegacyPage.getInitialProps

export default composePDP<Props>(ProductDetailPage)
